import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { FileText, Star, MessageSquare, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const { authHeaders } = useAuth();
  const [stats, setStats] = useState({ posts: 0, reviews: 0, pendingReviews: 0, comments: 0, pendingComments: 0, contacts: 0, cities: 0 });

  useEffect(() => {
    document.title = "Admin Dashboard | Pool Guru";
    loadStats();
  }, []);

  const loadStats = async () => {
    const headers = authHeaders();
    try {
      const [posts, reviews, comments, contacts, cities] = await Promise.all([
        api.get("/blog"),
        api.get("/admin/reviews", { headers }),
        api.get("/admin/comments", { headers }),
        api.get("/admin/contact", { headers }),
        api.get("/cities"),
      ]);
      setStats({
        posts: posts.data.length,
        reviews: reviews.data.length,
        pendingReviews: reviews.data.filter((r) => !r.is_approved).length,
        comments: comments.data.length,
        pendingComments: comments.data.filter((c) => !c.is_approved).length,
        contacts: contacts.data.length,
        cities: cities.data.length,
      });
    } catch {}
  };

  const cards = [
    { icon: FileText, label: "Blog Posts", count: stats.posts, link: "/admin/blog", color: "bg-brand-pink" },
    { icon: Star, label: "Reviews", count: stats.reviews, sub: `${stats.pendingReviews} pending`, link: "/admin/reviews", color: "bg-amber-500" },
    { icon: MessageSquare, label: "Comments", count: stats.comments, sub: `${stats.pendingComments} pending`, link: "/admin/comments", color: "bg-brand-blue" },
    { icon: Mail, label: "Contacts", count: stats.contacts, link: "/admin/contact", color: "bg-emerald-500" },
    { icon: MapPin, label: "City Pages", count: stats.cities, link: "/admin/cities", color: "bg-purple-500" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl font-extrabold mb-2">Dashboard</h1>
      <p className="text-slate-500 mb-10">Welcome back — here's what's happening with your site.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.link}
            className="bg-white rounded-2xl border border-slate-200 p-6 hover:shadow-md transition-shadow"
            data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className={`w-10 h-10 rounded-lg ${c.color} flex items-center justify-center mb-4`}>
              <c.icon className="w-5 h-5 text-white" />
            </div>
            <div className="text-3xl font-heading font-extrabold text-brand-navy">{c.count}</div>
            <div className="text-sm font-semibold text-slate-600 mt-1">{c.label}</div>
            {c.sub && <div className="text-xs text-brand-pink font-bold mt-1">{c.sub}</div>}
          </Link>
        ))}
      </div>
    </div>
  );
}
